import { render, staticRenderFns } from "./new-users.vue?vue&type=template&id=2db65a6d&"
import script from "./new-users.vue?vue&type=script&lang=ts&"
export * from "./new-users.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports